export default __webpack_public_path__ + "static/image_restauration@2x-e6e004a1af9c9eba623751632e68d66a.jpg";